import React, { useState, useEffect } from 'react';
import { Star } from 'lucide-react';

interface Review {
  username: string;
  stars: number;
  comment: string;
}

const reviews: Review[] = [
  {
    username: "c0d0x",
    stars: 5,
    comment: "I've tried tons of other providers, but recoil.club is the real hidden gem. Been using it for over a year now with zero bans. Autodetect is flawless, even on my crappy computer. The recoil control is unmatched it's a beam."
  },
  {
    username: "Xzarkhan",
    stars: 5,
    comment: "I’ve been using recoil.club for just over two years now, and I can confidently say this script is in a league of its own when it comes to recoil control in Rust. This is simply the best one out there."
  },
  {
    username: "militiaa",
    stars: 5,
    comment: "Been using this recoil script for a while now and it runs smoothly. The auto detection works exactly how you want it to. Attachment detection is accurate and works every time which makes everything feel natural."
  },
  {
    username: "Skoobzey",
    stars: 5,
    comment: "recoil.club is a top-tier premium script that stands out for its precision, performance, and ease of use. A+ support, Braden is fast, friendly, and knowledgeable during assistance."
  },
  {
    username: "Renji",
    stars: 5,
    comment: "recoil.club is the best on the market, it literally blows any other competitors out of the market. my account has lasted since day one of being here surviving all the ban waves.  braden has our backs, don't hesitate to buy."
  }
];

const ReviewsCarousel: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    let interval: NodeJS.Timeout;
    
    if (isAutoPlaying) {
      interval = setInterval(() => {
        handleNext();
      }, 5000);
    }

    return () => clearInterval(interval);
  }, [isAutoPlaying]);

  const handleNext = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex((prev) => (prev + 1) % reviews.length);
      setIsTransitioning(false);
    }, 300);
  };

  const handlePrev = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex((prev) => (prev - 1 + reviews.length) % reviews.length);
      setIsTransitioning(false);
    }, 300);
  };

  const handleDotClick = (index: number) => {
    if (isTransitioning || index === currentIndex) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex(index);
      setIsTransitioning(false);
    }, 300);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  return (
    <div className="relative">
      {/* Current Review */}
      <div 
        className={`transition-all duration-300 ${isTransitioning ? 'opacity-0 transform translate-x-4' : 'opacity-100 transform translate-x-0'}`}
        onMouseEnter={() => setIsAutoPlaying(false)}
        onMouseLeave={() => setIsAutoPlaying(true)}
      >
        <div className="relative bg-gray-900/40 backdrop-blur-sm rounded-xl p-6 border border-gray-700/50 shadow-[0_0_15px_rgba(0,0,0,0.3)]">
          {/* Gradient Overlay */}
          <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-purple-500/5 rounded-xl" />
          
          {/* Header Row */}
          <div className="flex justify-between items-start mb-4 relative">
            <div className="flex items-center space-x-3">
              <h3 className="text-xl font-semibold text-blue-400 drop-shadow-[0_0_8px_rgba(59,130,246,0.3)]">
                {reviews[currentIndex].username}
              </h3>
              <span className="px-3 py-1.5 bg-green-500/20 rounded-full text-sm font-medium text-green-400 flex items-center justify-center shadow-[0_0_10px_rgba(34,197,94,0.2)] border border-green-500/20">
                +rep
              </span>
            </div>
            <div className="w-8 h-8 rounded-full border border-gray-600 overflow-hidden shadow-[0_0_10px_rgba(0,0,0,0.3)] ring-1 ring-gray-500/30">
              <img 
                src="/images/rust.png" 
                alt="Rust" 
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Stars */}
          <div className="flex space-x-1 mb-6">
            {[...Array(5)].map((_, i) => (
              <Star
                key={i}
                className={`w-5 h-5 transition-all duration-300 ${
                  i < reviews[currentIndex].stars 
                    ? 'text-yellow-400 fill-yellow-400 drop-shadow-[0_0_5px_rgba(234,179,8,0.5)]' 
                    : 'text-gray-600'
                }`}
              />
            ))}
          </div>

          {/* Comment */}
          <p className="text-gray-300 text-left relative">
            {reviews[currentIndex].comment}
          </p>
        </div>
      </div>

      {/* Navigation Dots */}
      <div className="flex justify-center space-x-2 mt-6">
        {reviews.map((_, index) => (
          <button
            key={index}
            onClick={() => handleDotClick(index)}
            className={`h-2.5 rounded-full transition-all duration-300 ${
              index === currentIndex 
                ? 'bg-blue-500 w-8 shadow-[0_0_10px_rgba(59,130,246,0.5)]' 
                : 'bg-gray-600 w-2.5 hover:bg-gray-500'
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default ReviewsCarousel; 